import { Component, ElementRef, Input, OnInit, ViewEncapsulation } from '@angular/core';

import { TabLabel } from '../../directives/tab-label.directive';

@Component({
  selector: 'mcrai-tab-header',
  template: `<button class="mcrai-tab-header__label" [class.mcrai-tab-header__label--active]="isActive()" [mcrai-button]="getColor()">
  <ng-container *ngIf="getTemplateLabel()" [ngTemplateOutlet]="getTemplateLabel().template"></ng-container>
  <ng-container *ngIf="getStringLabel()">{{ getStringLabel() }}</ng-container>
</button>
`,
  styles: [`.mcrai-tab-header{display:block;flex:0 0 auto;margin-bottom:1px}.mcrai-tab-header__label{width:100%;min-width:140px;margin:0;text-transform:none!important}.mcrai-tabs--vertical .mcrai-tab-header__label{justify-content:flex-start}`],
  encapsulation: ViewEncapsulation.None,
  host: {
    '[class.mcrai-tab-header]': 'true'
  }
})
export class McRAITabHeader implements OnInit {
  @Input('label') private _label: TabLabel | string;
  @Input('index') private _index: number;
  @Input('active') private _active: boolean;

  constructor(
    private _elRef: ElementRef,
  ) { }

  ngOnInit() { }

  public getStringLabel(): string | null {
    return this._label instanceof TabLabel ? null : this._label;
  }

  public getTemplateLabel(): TabLabel | null {
    return this._label instanceof TabLabel ? this._label : null;
  }

  public getHostElement(): HTMLElement {
    return this._elRef.nativeElement;
  }

  public getStringIndex(): string {
    return (this._index + 1) + '.';
  }

  public isActive(): boolean {
    return this._active;
  }

  public getOffset(): number {
    return this._elRef.nativeElement.offsetLeft;
  }

  public getWidth(): number {
    return this._elRef.nativeElement.getBoundingClientRect().width;
  }

  public getColor(): string {
    return this._label instanceof TabLabel ? this._label.color : null;
  }

  focus() { }
}
